import base from "@/store/utils/api-route/base";

const api = {
	getListProvider: `${base.masterData}edc/list_provider_akun`,
	getListOutlet: `${base.masterData}meta/list_outlet_sorting_meta`,

	getListSettlementEdc: `${base.masterData}edc/list_riwayat_settlement_edc`,
};

export default api;
